import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Eko_Day extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.eka = [];

        this.state.tot = {};
        this.state.tot.netto = "";
        this.state.tot.brutto = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.st_oms();
    }

    componentWillUnmount(){
    }

    onScroll(event) {
        var body = document.getElementById("web-body");
        if (body.scrollTop > 150) {
          this.setState({top: 0})
          this.setState({info: 'small'})
        } else {
          this.setState({top: 1})
          this.setState({info: 'big:'+body.scrollTop})
        }

        if (true) {
            var offset = body.scrollTop;
            var start = body.scrollTop;
            var slut = body.scrollTop + window.innerHeight;

            for(var mnuid of this.state.mnus) {
                const element = document.getElementById(mnuid);
                if(!element || (element == null) || (element == undefined)) continue;
                var eltop = element.offsetTop;
                var elbot = element.offsetTop + element.offsetHeight;
                var brc = eltop >= start && eltop <= slut;
                //if(!brc) brc = elbot >= start && elbot <= slut;
                if(brc) {
                    this.setState({mnu_sel: mnuid});
                    return;
                }
            }
        }
    }
    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        css.overflow = "auto";
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }
    st_oms() {
        var self = this;

        if(this.state.dts == this.state.tdts) {
            self.st_act();
        }
        else
        {
            self.st_hist();
        }
    }
    st_act() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.st_dep";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                ///alert(JSON.stringify(ret));

                var sdo = ret.rco;
                var eka = Object.values(sdo.dpo);
                self.setState({ tot: sdo.tot, eka: eka });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    st_hist() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.sth_dep";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                var sdo = ret.rco;
                var eka = Object.values(sdo.dpo);
                self.setState({ tot: sdo.tot, eka: eka });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">OMSATT DAG</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
                </div>
                <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th>Avdelning</th>
                        <th>Netto</th>
                        <th>Brutto</th>
                        <th>Resultat</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.eka.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.row_open(row) }>
                        <td>{ row.text.toswe() }</td>
                        <td className="text-right">{ row.netto.cdipris() }</td>
                        <td className="text-right">{ row.brutto.cdipris() }</td>
                        <td className="text-right">{ row.resultat.cdipris() }</td>
                    </tr>
                    )}
                    <tr>
                        <th>Summa</th>
                        <th className="text-right">{ this.state.tot.netto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.brutto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.resultat.cdipris() }</th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="">
                <div className="txt_14">Avdelningar : { this.state.eka.length }</div>
            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Eko_Day;
